import * as React from 'react';
import Slider from 'rc-slider';

interface IRangeSliderProps {
    className?: string;
    activeMin: number;
    activeMax: number;
    min: number;
    max: number;

    onSlideChange?(values: number[]): void;
}

const RangeSlider: React.FunctionComponent<IRangeSliderProps> = props => {
    const { className, activeMin, activeMax, min, max, onSlideChange } = props;

    const handleChange = (values: number[]) => {
        onSlideChange(values);
    };

    return (
        <div className={className}>
            <Slider.Range
                allowCross={false}
                min={min}
                max={max}
                value={[activeMin, activeMax]}
                onChange={handleChange}
            />
        </div>
    );
};

RangeSlider.defaultProps = {
    className: '',
    onSlideChange: () => ({}),
}

export default RangeSlider;
